import { useLocation } from 'wouter';
import { TagBadge } from '@/components/shared/TagBadge';
import { formatTime } from '@/lib/utils';
import type { WeddingEvent } from '@/lib/types';

interface UpcomingPreviewProps {
  events: WeddingEvent[];
}

export function UpcomingPreview({ events }: UpcomingPreviewProps) {
  const [, navigate] = useLocation();

  if (events.length === 0) return null;

  return (
    <div>
      <p
        className="px-4 pt-4 pb-2 text-[11px] font-semibold uppercase tracking-widest"
        style={{ color: 'var(--color-text-muted)' }}
      >
        Upcoming
      </p>
      {events.map((event) => (
        <button
          key={event.id}
          className="w-full flex items-center gap-3 px-4 touch-target"
          style={{ minHeight: '44px' }}
          onClick={() => navigate('/schedule')}
          type="button"
        >
          <span
            className="flex-shrink-0 w-14 text-right"
            style={{
              fontSize: '13px',
              color: 'var(--color-text-muted)',
              fontFamily: 'var(--font-mono)',
            }}
          >
            {formatTime(new Date(event.startTime))}
          </span>
          <span
            className="flex-1 text-left truncate"
            style={{ fontSize: '14px', color: 'var(--color-text)' }}
          >
            {event.name}
          </span>
          <TagBadge category={event.category} />
        </button>
      ))}
    </div>
  );
}
